export const IRREGULAR_OP_COUNT_UPPER_DEFAULT = 4500; // 異常操作回数上限デフォルト値
